import { createBrowserRouter, Navigate } from 'react-router-dom';
import { AdminReviewPage } from '@/features/admin/pages/AdminReviewPage';
import { AdminRoute, ProtectedRoute } from '@/features/auth';
import { LoginPage } from '@/features/auth/pages/LoginPage';
import { ContentDetailPage } from '@/features/content/pages/ContentDetailPage';
import { FeedPage } from '@/features/feed/pages/FeedPage';
import { LandingPage } from '@/features/landing';
import { PrivacyPage, TermsPage } from '@/features/legal';
import { OnboardingPage } from '@/features/onboarding/pages/OnboardingPage';
import { ProfilePage } from '@/features/profile';
import { PublicContentDetailPage } from '@/features/public-feed';
import { SavedPage } from '@/features/saved/pages/SavedPage';

export const router = createBrowserRouter([
  {
    path: '/',
    element: <LandingPage />,
  },
  {
    path: '/login',
    element: <LoginPage />,
  },
  {
    path: '/terms',
    element: <TermsPage />,
  },
  {
    path: '/privacy',
    element: <PrivacyPage />,
  },
  {
    path: '/onboarding',
    element: (
      <ProtectedRoute>
        <OnboardingPage />
      </ProtectedRoute>
    ),
  },
  {
    path: '/feed',
    element: <FeedPage />,
  },
  {
    path: '/preview/:id',
    element: <PublicContentDetailPage />,
  },
  {
    path: '/content/:id',
    element: (
      <ProtectedRoute>
        <ContentDetailPage />
      </ProtectedRoute>
    ),
  },
  {
    path: '/saved',
    element: (
      <ProtectedRoute>
        <SavedPage />
      </ProtectedRoute>
    ),
  },
  {
    path: '/profile',
    element: (
      <ProtectedRoute>
        <ProfilePage />
      </ProtectedRoute>
    ),
  },
  {
    path: '/admin',
    element: (
      <AdminRoute>
        <AdminReviewPage />
      </AdminRoute>
    ),
  },
  {
    path: '*',
    element: <Navigate to="/" replace />,
  },
]);
